export default __webpack_public_path__ + "static/media/settings-icon.3796ee86.svg";